import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalController, Platform } from "ionic-angular";
import * as moment from "moment";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

@Component({
  selector: "issue",
  templateUrl: "issue.html",
})
export class IssueComponent {
  @Input() data;
  @Input() status;
  @Input() selectedData;
  @Input() disabled: boolean = false;
  @Input() taskCount: number = 0;
  expanded: boolean = true;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateItem: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: PlanOfCareDataService,
    public modalCtrl: ModalController,
    public plt: Platform
  ) {}

  toggle() {
    this.expanded = !this.expanded;
  }

  select(data) {
    if (!data.type) {
      data.type = "issue";
    }

    this.onSelect.emit(data);
  }

  updateItem(event) {
    this.onUpdateItem.emit(event);
  }

  presentAcceptModal() {
    let acceptModal = this.modalCtrl.create(
      "AddItemPage",
      {
        modalType: "acceptIssue",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );

    acceptModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.updateIssueStatus(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({ data: this.data, action: "acceptIssue" });
            this.dataService.getIssuesCount();
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });

    acceptModal.present();
  }

  presentDeclineModal() {
    let declineModal = this.modalCtrl.create(
      "UpdateStatusPage",
      {
        modalType: "declineIssue",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );

    declineModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.updateIssueStatus(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({ data: this.data, action: "declineIssue" });
            this.dataService.getIssuesCount();
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });

    declineModal.present();
  }

  presentResolveIssueModal() {
    let type = "resolveIssue";
    if (this.data && this.data.recordTypeLookupCode == "CL009.4")
      type = "resolveTask";
    let resolveIssueModal = this.modalCtrl.create(
      "UpdateStatusPage",
      {
        modalType: type,
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );

    var date = moment().format("YYYY-MM-DD HH:mm:ss");
    var finalDate = moment.utc(date).local().format("MM/DD/YYYY");

    resolveIssueModal.onDidDismiss((data) => {
      if (data) {
        this.dataService
          .updateIssueStatus(this.data.uuid, data, finalDate)
          .subscribe(
            (data) => {
              this.updateItem({ data: this.data, action: type });
              this.dataService.getIssuesCount();
            },
            (err) => {
              // console.error(err);
            }
          );
      }
    });

    resolveIssueModal.present();
  }

  presentAddGoalModal() {
    let addGoalModal = this.modalCtrl.create(
      "AddItemPage",
      {
        modalType: "addGoal",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );

    addGoalModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.addGoalAndIntervention(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({
              data: this.data,
              action: "addGoal",
              newData: data,
            });
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });

    addGoalModal.present();
  }

  presentDetailsModal() {
    let type = "issue";
    if (this.data && this.data.recordTypeLookupCode == "CL009.4") type = "task";
    let detailsModal = this.modalCtrl.create(
      "DetailsPage",
      {
        status: this.status,
        type: type,
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );

    detailsModal.onDidDismiss((data) => {});
    detailsModal.present();
  }

  checkActiveIssueTaskCount(data) {
    let status = true;
    if (this.data.recordTypeLookupCode == "CL009.4") {
      let count = this.taskCount;
      if (count > 1) {
        status = true;
      } else {
        status = false;
      }
    }
    return status;
  }

  public type = () =>
    this.data.recordTypeLookupCode == "CL009.4" ? "task" : "issue";
}



// WEBPACK FOOTER //
// ./src/components/common/issue/issue.ts